<div class="bg-light dark:bg-transparent min-vh-100 d-flex flex-row align-items-center position-relative">
  <lib-auth-language-switcher></lib-auth-language-switcher>
  <c-container breakpoint="md">
    <c-row class="justify-content-center">
      <c-col lg="8" xl="6">
        <c-card-group>
          <c-card class="p-4 shadow-sm border-0">
            <c-card-body>
              <form cForm [formGroup]="registerForm" (ngSubmit)="onSubmit()">
                <!-- Logo -->
                <app-logo class="mb-4 d-block mx-auto" style="max-width: 180px;"></app-logo>

                <h2 class="mb-3">{{ 'register.title' | translate }}</h2>
                <p class="text-body-secondary mb-4">{{ 'register.subtitle' | translate }}</p>

                <!-- First Name -->
                <c-input-group class="mb-3">
                  <span cInputGroupText>
                    <svg cIcon name="cilUser"></svg>
                  </span>
                  <input
                    cFormControl
                    formControlName="first_name"
                    type="text"
                    [placeholder]="'register.first_name_placeholder' | translate"
                    [class.is-invalid]="firstNameCtrl().touched && firstNameCtrl().invalid"
                    unassistedInput
                  />
                  @if (firstNameCtrl().touched && firstNameCtrl().invalid) {
                    <c-form-feedback [valid]="false">
                      @if (firstNameCtrl().errors?.['required']) {
                        {{ 'register.first_name_required' | translate }}
                      }
                      @if (firstNameCtrl().errors?.['minlength']) {
                        {{ 'register.first_name_minlength' | translate }}
                      }
                    </c-form-feedback>
                  }
                </c-input-group>

                <!-- Last Name -->
                <c-input-group class="mb-3">
                  <span cInputGroupText>
                    <svg cIcon name="cilUser"></svg>
                  </span>
                  <input
                    cFormControl
                    formControlName="last_name"
                    type="text"
                    [placeholder]="'register.last_name_placeholder' | translate"
                    unassistedInput
                  />
                </c-input-group>

                <!-- Email -->
                <c-input-group class="mb-3">
                  <span cInputGroupText>
                    <svg cIcon name="cilEnvelopeClosed"></svg>
                  </span>
                  <input
                    cFormControl
                    formControlName="email"
                    type="email"
                    [placeholder]="'register.email_placeholder' | translate"
                    [class.is-invalid]="emailCtrl().touched && emailCtrl().invalid"
                    unassistedInput
                  />
                  @if (emailCtrl().touched && emailCtrl().invalid) {
                    <c-form-feedback [valid]="false">
                      @if (emailCtrl().errors?.['required']) {
                        {{ 'register.email_required' | translate }}
                      }
                      @if (emailCtrl().errors?.['email']) {
                        {{ 'register.email_invalid' | translate }}
                      }
                      @if (emailCtrl().errors?.['emailExists']) {
                        {{ 'register.email_exists' | translate }}
                      }
                    </c-form-feedback>
                  }
                  @if (emailCtrl().pending) {
                    <c-form-feedback>
                      {{ 'register.email_checking' | translate }}
                    </c-form-feedback>
                  }
                </c-input-group>

                <!-- Password -->
                <c-input-group class="mb-3">
                  <span cInputGroupText>
                    <svg cIcon name="cilLockLocked"></svg>
                  </span>
                  <input
                    cFormControl
                    formControlName="password"
                    type="password"
                    [placeholder]="'register.password_placeholder' | translate"
                    [class.is-invalid]="passwordCtrl().touched && passwordCtrl().invalid"
                    unassistedInput
                  />
                  @if (passwordCtrl().touched && passwordCtrl().invalid) {
                    <c-form-feedback [valid]="false">
                      @if (passwordCtrl().errors?.['required']) {
                        {{ 'register.password_required' | translate }}
                      }
                      @if (passwordCtrl().errors?.['minlength']) {
                        {{ 'register.password_minlength' | translate }}
                      }
                    </c-form-feedback>
                  }
                </c-input-group>

                <!-- Sponsor ID (only if domain_id === 0) -->
                @if (domainId() === 0) {
                  <c-input-group class="mb-3">
                    <span cInputGroupText>
                      <svg cIcon name="cilUser"></svg>
                    </span>
                    <input
                      cFormControl
                      formControlName="sponsor_id"
                      type="text"
                      [placeholder]="'register.sponsor_id_placeholder' | translate"
                      unassistedInput
                    />
                  </c-input-group>
                }

                <!-- Language -->
                <c-input-group class="mb-4">
                  <span cInputGroupText>
                    <svg cIcon name="cilGlobeAlt"></svg>
                  </span>
                  <select
                    cSelect
                    formControlName="language"
                    name="language"
                    [class.is-invalid]="languageCtrl().touched && languageCtrl().invalid"
                  >
                    @for (lang of languages; track lang.code) {
                      <option [value]="lang.code">
                        {{ lang.name }}
                      </option>
                    }
                  </select>
                  @if (languageCtrl().touched && languageCtrl().invalid) {
                    <c-form-feedback [valid]="false">
                      @if (languageCtrl().errors?.['required']) {
                        {{ 'register.language_required' | translate }}
                      }
                    </c-form-feedback>
                  }
                </c-input-group>

                <!-- mCaptcha Widget -->
                <div class="mb-4">
                  <div id="mcaptcha-widget" class="mcaptcha__widget-container"></div>
                  @if (captchaError()) {
                    <small class="text-danger">
                      {{ 'register.captcha_required' | translate }}
                    </small>
                  }
                </div>

                <!-- Submit + Back -->
                <c-row>
                  <c-col xs="6">
                    <button
                      cButton
                      color="primary"
                      type="submit"
                      class="w-100"
                      [disabled]="!canSubmit()"
                    >
                      {{ 'register.register_button' | translate }}
                    </button>
                  </c-col>
                  <c-col xs="6" class="text-end">
                    <button
                      cButton
                      color="link"
                      type="button"
                      routerLink="/login"
                    >
                      {{ 'register.back_to_login' | translate }}
                    </button>
                  </c-col>
                </c-row>

                <!-- Messages -->
                @if (success()) {
                  <div class="alert alert-success mt-4">
                    {{ 'register.success_message' | translate }}
                  </div>
                }
                @if (error()) {
                  <div class="alert alert-danger mt-4">
                    {{ error() }}
                  </div>
                }
              </form>
            </c-card-body>
          </c-card>
        </c-card-group>
      </c-col>
    </c-row>
  </c-container>
</div>